<script>
    import axios from 'axios';
    import { FLTOPS_BACKEND } from 'src/config';
    let key = (new URL(document.location)).searchParams.get('key');
    let signed = false;
    let pdfUrl;
    let checked = false;
    let config = {};

    const fetchJob = async () => {
        signed = true;
        await axios.post(`${FLTOPS_BACKEND}/hiring/api/public/offer-sign/`, { key });
    };
    const showAgreement = async () => {};
    const fetchConfig = async () => {
        config = (await axios.get(`${FLTOPS_BACKEND}/public/api/config/`)).data;
    };
    fetchConfig();

    $: pdfUrl = `${FLTOPS_BACKEND}/media/offers/${key}.pdf?#zoom=85&scrollbar=0&toolbar=0&navpanes=0"`;
</script>
{#if signed}
    <div class="thank-you">
        Thank you! You have successfully signed your offer letter. We'll get in touch soon.
    </div>
{:else}
    {#if key}
    <object width="100%" height="100%" type="application/pdf" data={pdfUrl}  title="Offer Letter" aria-label="Offer Letter">
    </object>
    <div class="sign-ui">
        <div class="description">You can digitally sign this offer letter on this page.</div>
        <div class="sign-ui__check">
            <label for="check">
                <input type="checkbox" name="check" bind:checked={checked}>
                I agree to use Boutique Air signature platform for this signature.
                I have read and agree with <a href="#" on:click={showAgreement}>Agreement</a>
            </label>
        </div>
        <div class="agreement-text">
            {@html config.offer_text}
        </div>
        <div class="field">
            <label for="">Your email key</label>
            <input type="text" bind:value={key}>
            <button on:click={fetchJob} disabled={!checked}>Sign electronically</button>
        </div>
    </div>
    {:else}
        To access this you need to have the code
    {/if}
{/if}
<style>
    :global(body) {
        margin: 0;
        padding: 0;
    }
    .agreement-text {
width: 100%;
    height: 300px;
    overflow-y: scroll;
    /* border: 3px solid #000; */
    padding: 0 5px;
    box-sizing: border-box;
    box-shadow: inset 0px 0px 7px #00000057;
    }
    .thank-you {
        background: #79e88c;
        width: 300px;
        margin: 0 auto;
        padding: 10px 20px;
        border-radius: 0 0 5px 5px;
    }
    .description {
        margin-bottom: 10px;
    }
    .sign-ui {
        position: fixed;
        bottom: 0;
        width: calc(100% - 60px);
        background: #fff;
        border-radius: 10px 10px 0 0;
        margin: 0 10px;
        padding: 10px;
        border: 10px solid #006FE8;
        border-bottom: 0;

    }
    .sign-ui__check {
        margin-bottom: 10px;
    }
    .field {
        color: #878787;
        display: flex;
        align-items: center;
    }
    label {
        margin-right: 5px;
        line-height: 13px;
    }
    input {
        margin: 0 5px 0 0;
        border-radius: 5px;
    }
    button {
        background: #498ce2;
        color: #fff;
        border: 0;
        margin: 0;
    }
    button[disabled] {
        background: #ababab;
    }
</style>
